import React from 'react'
import { Alert } from 'components'
import { Chip } from 'components/Form'
import { MicErrorsStyles } from '../Style'

const MicErrorsAlert = (props) => {
    const { handleAlert } = props

    const errors = [
        { label: "שהמיקרופון לא על השתקה (mute)", icon: "microphone-slash", color: "gray" },
        { label: "שהדיבורית קרובה לפה של התלמיד", icon: "headset", color: "orange" },
        { label: "שהמיקרופון הנכון נבחר במחשב (ולא מצלמה או התקן אחר)", icon: "volume-high", color: "rating1" },
        { label: "שהתלמיד מדבר בקול ברור (ולא בלחישה)", icon: "lips", color: "pink" }
    ]

    return (
        <Alert
            systemUI
            handleAlert={handleAlert}
            title="בואו נבדוק כמה דברים:"
        >
            <MicErrorsStyles>
                {errors.map((err) =>
                    <div className='error-item'>
                        <Chip size="small" type="icon" round color={err.color}>
                            <i class={`fa-light fa-${err.icon}`}></i>
                        </Chip>
                        {err.label}
                    </div>
                )}
            </MicErrorsStyles>
        </Alert>
    )
}

export default MicErrorsAlert